(() => {
  const ROOT_SELECTOR = '[data-jrb-how-it-works]';

  class JrbHowItWorks {
    constructor(root) {
      this.root = root;
      this.steps = Array.from(root.querySelectorAll('[data-jrb-how-it-works-step]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intersectionObserver = null;
    }

    init() {
      if (this.root.dataset.jrbHowItWorksInitialized === 'true') {
        return;
      }

      this.root.dataset.jrbHowItWorksInitialized = 'true';
      this.root.classList.add('is-enhanced');

      this.setupObserver();
    }

    destroy() {
      this.steps.forEach((step) => {
        step.classList.remove('is-visible');
      });

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }

      this.root.classList.remove('is-enhanced');
      this.root.dataset.jrbHowItWorksInitialized = 'false';
    }

    setupObserver() {
      if (!('IntersectionObserver' in window) || this.reducedMotion) {
        this.steps.forEach((step) => {
          step.classList.add('is-visible');
        });
        return;
      }

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, {
        threshold: 0.25,
        rootMargin: '0px 0px -8% 0px'
      });

      this.steps.forEach((step) => {
        this.intersectionObserver.observe(step);
      });
    }
  }

  const instances = new WeakMap();

  const initSection = (root) => {
    if (!root || instances.has(root)) {
      return;
    }

    const instance = new JrbHowItWorks(root);
    instance.init();
    instances.set(root, instance);
  };

  const destroySection = (root) => {
    const instance = instances.get(root);

    if (!instance) {
      return;
    }

    instance.destroy();
    instances.delete(root);
  };

  const initAll = (container = document) => {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroySection);
  });
})();
